import { PermissionsEnum } from "@/auth/interfaces";
import { a11yProps, EstadoProspectoEnum, hasPermission, ROUTER_PATHS, sizeTab, texto, useCheckPermissions } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TableProspectoCorporativo from "../../shared/component/table_prospecto_corporativo/TableProspectoCorporativo";

export default function ProspectoCorporativoPage() {
  useCheckPermissions(PermissionsEnum.api_view_prospectocorporativo);

  const [valueTab, setValueTab] = useState(0);


  return (
    <SingleTableBoxScene title={"Prospectos Corporativos"}
      py={2}
      enableRedirect={hasPermission(PermissionsEnum.api_add_prospectocorporativo)}
      urlRedirect={ROUTER_PATHS.ventasCorporativas.prospectoCrearCorporativo}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Prospectos'} {...a11yProps(0)} />
          <Tab label={texto.realizadas} {...a11yProps(1)} />
          <Tab label={texto.cancelado} {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableProspectoCorporativo/>
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableProspectoCorporativo
          enableEditing={false}
          showCustomActionBtnSpace={false}
          estado_prospecto={EstadoProspectoEnum.FINALIZADO}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TableProspectoCorporativo
          enableEditing={false}
          showCustomActionBtnSpace={false}
          estado_prospecto={EstadoProspectoEnum.CANCELADO}
        />
      </CustomTabPanel>

    </SingleTableBoxScene >
  );

}

